export default [
    {
        "name": "全部",
        "code": "11000",
        "city": [
            {
                "name": "金融",
                "code": "110000",
            },
            {
                "name": "电商",
                "code": "120000",
                "city": [
                  {
                    "name": "唯品会",
                    "code": "120100",
                  },
                  {
                    "name": "京东",
                    "code": "120101",
                  },
                  {
                    "name": "拼多多",
                    "code": "120102",
                  }
                ]
            },
            {
                "name": "房产",
                "code": "140000",
                "city": [
                  {
                    "name": "房产人群包",
                    "code": "140100",
                  }
                ]
            },
            {
                "name": "旅游",
                "code": "150000",
                "city": [
                  {
                    "name": "旅游人群包",
                    "code": "150100",
                  }
                ]
            },
            {
                "name": "教育",
                "code": "160000",
                "city": [
                  {
                    "name": "教育人群包",
                    "code": "160100",
                  }
                ]
            },
        ]
    },
]
